publishingApp.controller('reportsController', ['$scope', '$rootScope', '$state', '$uibModal', 'dbData', '$log', '$resource', 'DTOptionsBuilder', 'DTColumnDefBuilder', '$cookies', '$http', '$debounce', 'fileUpload', function ($scope, $rootScope, $state, $uibModal, dbData, $log, $resource, DTOptionsBuilder, DTColumnDefBuilder, $cookies, $http, $debounce, fileUpload) {
    
    $scope.reports = {
        "daily": {"name": "Daily Reports", data: []},
        "weekly": {"name": "Weekly Reports", data: []},
        "adhoc": {"name": "Ad Hoc Reports", data: []},
    };

    console.log($state.current);
    console.log($state.params);

    // SA / PCM / PAM / KPM
    if($rootScope.user.roles.includes('super-admin')
        || $rootScope.user.roles.includes('publishing-content-manager')
        || $rootScope.user.roles.includes('publishing-account-manager')
        || $rootScope.user.roles.includes('key-publisher-manager')){

        $scope.reports.adhoc.data.push({
            name: "Exported Courses List",
            metabase: "/question/44-exported-courses-list",
            metabaseId: 44,
            id: 6,
            endpoint: '/api/reports/44',
        });

        $scope.reports.adhoc.data.push({
            name: "Publisher/Career Report",
            metabase: "/question/159-publisher-careers-per-course-cumulative",
            metabaseId: 159,
            id: 8,
            endpoint: '/api/reports/159',
        });
    }

    // SA / PCM / PAM
    if($rootScope.user.roles.includes('super-admin')
        || $rootScope.user.roles.includes('publishing-content-manager')
        || $rootScope.user.roles.includes('publishing-account-manager')){
            
        $scope.reports.daily.data.push({
            name: "Daily Report for Unassigned Courses",
            metabase: "/question/86-daily-report-for-unassigned-courses",
            metabaseId: 86,
            id: 5,
            endpoint: '/api/reports/86',
        });

        $scope.reports.weekly.data.push({
            name: "Outstanding Post live edits",
            metabase: "/question/42-outstanding-post-live-edits",
            metabaseId: 42,
            id: 7,
            endpoint: '/api/reports/42',
        });
    }

    // PCM only
    if($rootScope.user.roles.includes('publishing-content-manager')){
            
        $scope.reports.daily.data.push({
            name: "Daily Report for PCM",
            metabase: "/question/46-daily-report-for-pcms",
            metabaseId: 46,
            id: 1,
            endpoint: '/api/reports/46',
        });

        $scope.reports.daily.data.push({
            name: "Daily report for CC Test Courses",
            metabase: "/question/45-daily-report-for-cc-test-courses",
            metabaseId: 45,
            id: 2,
            endpoint: '/api/reports/45',
        });
    }

    // PAM only
    if($rootScope.user.roles.includes('publishing-account-manager')){
            
        $scope.reports.daily.data.push({
            name: "Daily Report for PAM",
            metabase: "/question/47-daily-report-for-pams",
            metabaseId: 47,
            id: 3,
            endpoint: '/api/reports/47',
        });

        $scope.reports.daily.data.push({
            name: "Daily report for SP Test Courses",
            metabase: "/question/43-daily-report-for-sp-test-courses",
            metabaseId: 43,
            id: 4,
            endpoint: '/api/reports/43',
        });
    }


    if ($state.current.name === "report") {
        $scope.currentReport = {};

        console.dir($scope.reports);

        switch(parseInt($state.params.id)){
            case 1:
            case 2:
                if(!$rootScope.user.roles.includes('publishing-content-manager')){

                    $rootScope.pushAlerts("Sorry, you don't have permission to see this report");
                    $log.info("User unauthorised to view the report");
                    
                    setTimeout(function(){
                        $state.go('index');
                    }, 1500);
                }

                $scope.currentReport = getObjectByPropertyValue($scope.reports.daily.data, 'id', $state.params.id);

                if(typeof $scope.currentReport !== "undefined"){
                    getMetabaseUrl($scope.currentReport.endpoint);
                }

                break;
            case 3:
            case 4:
                if(!$rootScope.user.roles.includes('publishing-account-manager')){

                    $rootScope.pushAlerts("Sorry, you don't have permission to see this report");
                    $log.info("User unauthorised to view the report");
                    
                    setTimeout(function(){
                        $state.go('index');
                    }, 1500);
                }

                $scope.currentReport = getObjectByPropertyValue($scope.reports.daily.data, 'id', $state.params.id);

                if(typeof $scope.currentReport !== "undefined"){
                    getMetabaseUrl($scope.currentReport.endpoint);
                }

                break;
            case 5:
            case 7:
            case 9:
                if(!($rootScope.user.roles.includes('super-admin')
                    || $rootScope.user.roles.includes('publishing-content-manager')
                    || $rootScope.user.roles.includes('publishing-account-manager'))){

                    $rootScope.pushAlerts("Sorry, you don't have permission to see this report");
                    $log.info("User unauthorised to view the report");
                    
                    setTimeout(function(){
                        $state.go('index');
                    }, 1500);
                }

                $scope.currentReport = ($state.params.id == 5) ? getObjectByPropertyValue($scope.reports.daily.data, 'id', $state.params.id) : getObjectByPropertyValue($scope.reports.weekly.data, 'id', $state.params.id);

                if(typeof $scope.currentReport !== "undefined"){
                    getMetabaseUrl($scope.currentReport.endpoint);
                }

                break;
            case 6:
            case 8:
                if(!($rootScope.user.roles.includes('super-admin')
                    || $rootScope.user.roles.includes('publishing-content-manager')
                    || $rootScope.user.roles.includes('publishing-account-manager')
                    || $rootScope.user.roles.includes('key-publisher-manager'))){

                    $rootScope.pushAlerts("Sorry, you don't have permission to see this report");
                    $log.info("User unauthorised to view the report");
                    
                    setTimeout(function(){
                        $state.go('index');
                    }, 1500);
                }

                $scope.currentReport = getObjectByPropertyValue($scope.reports.adhoc.data, 'id', $state.params.id);

                if(typeof $scope.currentReport !== "undefined"){
                    getMetabaseUrl($scope.currentReport.endpoint);
                }

                break;
            default:
                $rootScope.pushAlerts("Sorry, the report you are after does not exist.");
                $log.info("Report does not exist");
                
                setTimeout(function(){
                    $state.go('index');
                }, 1500);
        }
    }

    function getMetabaseUrl(endpoint){
        dbData.get(endpoint, {headers: {'Authorization':'Bearer ' + $cookies.get('access_token_' + document.getElementById('main-doc').dataset.env)}}).then(
            function (response) {
                console.log(response.data);

                $('iframe').remove();
                var iframe = document.createElement("iframe");
                var embeddingContainer = document.getElementById('embeddingContainer');

                iframe.style.height = '950px';
                iframe.style.width = '100%';
                iframe.setAttribute("src", response.data);
               
                embeddingContainer.appendChild(iframe); 
            },
            function (error) {
                $('.page-loading').addClass('hidden');
                $rootScope.pushAlerts('Error while loading report');
            }
        );
    }

    /**
     * Get Object from array based on property value pair
     * @param {array} source
     * @param {string} property
     * @param {any} value
     * @returns {object}
     */
    function getObjectByPropertyValue(source, property, value){
        return source.filter(function(obj){
            return obj[property] == value;
        })[0];
    }

    /**
     * Get Object Index in Array based on property value pair
     * 
     * @param {array} source
     * @param {string} property
     * @param {any} value
     * @returns {number} index of object within the array
     */
    function getObjectIndexByPropertyValue(source, property, value){
        return source.map(function(obj){
            return obj[property];
        }).indexOf(value);
    }
}]);